var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Status-Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Status-Error",
    stroke: "#DC0000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.277840, 1.472019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5110149,3.57770876 L15.9971074,14.5498938 C16.4910859,15.5378508 16.0906372,16.7391969 15.1026802,17.2331754 C14.8249693,17.3720308 14.5187432,17.444321 14.208253,17.444321 L3.23606798,17.444321 C2.13149848,17.444321 1.23606798,16.5488905 1.23606798,15.444321 C1.23606798,15.1338308 1.30835816,14.8276047 1.4472136,14.5498938 L6.93330612,3.57770876 C7.42728462,2.58975177 8.6286307,2.18930308 9.61658769,2.68328157 C10.0036425,2.87680898 10.3174875,3.19065396 10.5110149,3.57770876 Z",
    id: "Triangle"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.35397989,
    y1: 9.73807217,
    x2: 11.0903411,
    y2: 14.4744334,
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.0903411,
    y1: 9.73807217,
    x2: 6.35397989,
    y2: 14.4744334,
    id: "Path-7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/Status-Error.e6e4f216.svg";
export { ForwardRef as ReactComponent };